/** Публичные ассеты из public/assets/guardians (копия gDaksby/assets/guardians). */
export function assetUrl(path: string): string {
  const clean = path.replace(/^\/+/, "").replace(/^assets\/guardians\//, "")
  const base = import.meta.env.BASE_URL || "/"
  const prefix = base.endsWith("/") ? base : `${base}/`
  return `${prefix}assets/guardians/${clean}`
}
